import { AxiosError } from "axios";
import { AlertSetterType } from "contexts/AlertProvider";
import { NavigateFunction } from "react-router-dom";

export const axiosErrorHandler = (navigate:NavigateFunction, setAlert:AlertSetterType)=>(err : AxiosError)=>{
    if(err.response?.status === 401)
        navigate('/auth/login')
    else if(err.response?.status === 403)
        setAlert('error', 'You are not authorized to do this action')
    else
        setAlert('error', err.message + ' contact admin for further detail' as string);
}